import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=790bb965&scoped=true&"
import script from "./Moderation.vue?vue&type=script&lang=js&"
export * from "./Moderation.vue?vue&type=script&lang=js&"
import style0 from "./Moderation.vue?vue&type=style&index=0&id=790bb965&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790bb965",
  null
  
)

export default component.exports